<template>
  <div 
    class="timeline" 
    :style="`--partner-dot-color: ${$partnerACL.getBackgroundColorApp()}`"
  >
    <div 
      v-for="(item, index) in route"
      :key="index"
      class="timeline-item d-flex flex-column"
    >
      <span class="f-s-xs">{{ item }}</span>
    </div>
  </div>
</template>

<script>
export default {
    name: "TimelineLong",
    props: {
        route: {
            type: Array,
            default: () => ([
                "Route 1",
                "Route 2",
                "Route 3"
            ]) 
        }
    }
}
</script>

<style lang="scss" scoped>
.timeline {
    position: relative;
    padding-left: 16px;
}

.timeline-item {
    text-align: left;
    position: relative;
    padding-left: 8px;
    height: 30px;
    /* Jarak antar item */
}

.timeline-item:last-child {
    margin-bottom: 0;
}

.timeline-item::before {
    content: "";
    position: absolute;
    left: -10px;
    top: 3px;
    width: 12px;
    height: 12px;
    background-color: var(--partner-dot-color);
    border-radius: 50%;
}

.timeline-item::after {
    content: "";
    position: absolute;
    left: -5px;
    top: 16px;
    width: 2px;
    height: 20px;
    border-left: 2px dashed #aaa;
}

/* Hapus garis pada item terakhir */
.timeline-item:last-child::after {
    display: none;
}
</style>